// src/api/api.ts
// Re-export centralized API clients
export { apiClient as authenticatedApiClient, authApiClient } from '../utils/axiosWithAuth';

// Re-export types for backward compatibility  
export type { ApiResponse } from '../utils/axiosWithAuth';

// Re-export API base URL constant
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:3001";

// Legacy safeApi wrapper for backward compatibility
export async function safeApi<T>(
  req: () => Promise<import('axios').AxiosResponse<import('../utils/axiosWithAuth').ApiResponse<T>>>
): Promise<import('../utils/axiosWithAuth').ApiResponse<T>> {
  try {
    const { data } = await req();
    return data;
  } catch (error) {
    const err = error as import('axios').AxiosError<import('../utils/axiosWithAuth').ApiResponse<T>>;
    if (err.response?.data) {
      return err.response.data as import('../utils/axiosWithAuth').ApiResponse<T>;
    }
    return {
      status: false,
      message: "Network error. Please try again later.",
    };
  }
}
